// Components - UI
import Scroller from '@/components/ui/Scroller/Scroller.vue';

// Services
import UsersService from '@/services/UsersService';
import RetailersService from '@/services/RetailersService';
import MultiSitesService from '@/services/MultiSitesService';
import GooglePlacesService from '@/services/GooglePlacesService';
import SubscriptionsService from '@/services/SubscriptionsService';
import ResetPasswordService from '@/services/ResetPasswordService';
import ServiceProvidersService from '@/services/ServiceProvidersService';

// Modules
import placeParser from '@/modules/place-parser';

// EventBus
import { EventBus } from '@/EventBus.js';

// Vendor
import Validator from 'validator';
import moment from 'moment';
import _ from 'lodash';

export default {

  name: 'admin',

  components: {
    Scroller
  },

  data: function() {
    return {
      // Page
      viewMode: null,
      accountType: null,
      saving: false,

      // Shared
      user: {},

      // Service Provider
      serviceProvider: {},

      // Multisite
      searchStringRetailers: '',
      multisite: {
        retailers: []
      },
      retailerResults: [],

      // Retailer
      searchString: null,
      textSearchDebounce: null,
      placeResults: []
    }
  },

  created: function() {
    // Retailers - Search google places
    this.textSearchDebounce = _.debounce((scope) => {
      scope.places = null;

      GooglePlacesService.textSearch(scope.searchString)
        .then((res) => {
          scope.placeResults = res.data;
        });
    }, 750);
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  computed: {
  },

  methods: {
    openCreateAccount: function(accountType) {
      this.viewMode = 'createAccount';
      this.accountType = accountType;

      if(accountType == 'multisite') {
        this.getRetailers();
      }
    },

    resetComponent: function() {
      // Page
      this.viewMode = null;
      this.accountType = null;
      this.saving = false;

      // Shared
      this.user = {};

      // Service Provider
      this.serviceProvider = {};

      // Multisite
      this.multisite = {
        retailers: []
      };
      this.searchStringRetailers = null;
      this.retailerResults = [];

      // Retailer
      this.searchString = null;
      this.placeResults = [];
    },


    // Retailer methods
    // ----------------
    search: function() {
      if(!this.searchString || (this.searchString && this.searchString.trim().length == 0)) {
        this.textSearchDebounce.cancel();
        return;
      }

      this.textSearchDebounce(this);
    },

    doCreateRetailer: function(place) {
      if(!this.user.fullName || (this.user.fullName && this.user.fullName.trim().length == 0)) {
        EventBus.dispatchErrorEvent('Error! You must provide a full name.');
      }
      else {
        if(!this.user.emailAddress || (this.user.emailAddress && this.user.emailAddress.trim().length == 0) || !Validator.isEmail(this.user.emailAddress)) {
          EventBus.dispatchErrorEvent('Error! You must provide a valid email address.');
        }
        else {
          this.saving = true;

          UsersService.getAll({emailAddress: encodeURIComponent(this.user.emailAddress)})
            .then((res) => {
              if(res.data.length > 0) {
                EventBus.dispatchErrorEvent('Error! A user already exists with the provided email address.');
                this.saving = false;
              }
              else {
                // Create Retailer if not already exists (lookup place id)
                RetailersService.getAll({googlePlaceId: place.place_id})
                .then((res) => {
                  console.log('res', res);
                  if(res.data.length == 0) {
                    // Get place information from GoogleMapsService
                    GooglePlacesService.getPlaceDetails(place.place_id)
                    .then((res) => {
                      let place = res.data;
                      let parsedPlace = placeParser.parsePlace(res.data);

                      let retailerToCreate = {
                        googlePlaceId: place.place_id,
                        name: place.name,
                        address: parsedPlace.address,
                        city: parsedPlace.city || parsedPlace.county,
                        postcode: parsedPlace.zip_code,
                        lat: place.geometry.location.lat,
                        lng: place.geometry.location.lng
                      };

                      // Create retailer
                      RetailersService.createOne(retailerToCreate)
                      .then((res) => {
                        let subscriptionData = {
                          type: 'retailer',
                          package: 'corporate',
                          retailer: res.data.id,
                          subscriptionTermMonths: 12
                        };

                        this.createSubscription(subscriptionData);
                      });
                    });
                  }
                  // Retailer with this Place ID already exists
                  else {
                    let subscriptionData = {
                      type: 'retailer',
                      package: 'corporate',
                      retailer: res.data[0].id,
                      subscriptionTermMonths: 12
                    };

                    this.createSubscription(subscriptionData);
                  }
                });
              }
            })
            .catch((err) => {
              this.saving = false;
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
            });
        }
      }
    },


    // Multisite Retailer methods
    // --------------------------
    getRetailers: function() {
      RetailersService.getAll(null, null, null, 'name ASC')
        .then((res) => {
          this.retailerResults = res.data;
        });
    },

    addRetailerToMultisite: function(retailer) {
      console.log('add retailer running...');
      let matches = this.multisite.retailers.find((item) => {
        return item.id == retailer.id;
      });

      if(!matches) {
        this.multisite.retailers.push(retailer);
      }
    },

    removeRetailerFromMultisite: function(index) {
      this.multisite.retailers.splice(index, 1);
    },

    doCreateMultisite: function() {
      if(!this.user.fullName || (this.user.fullName && this.user.fullName.trim().length == 0)) {
        EventBus.dispatchErrorEvent('Error! You must provide a full name.');
      }
      else {
        if(!this.user.emailAddress || (this.user.emailAddress && this.user.emailAddress.trim().length == 0) || !Validator.isEmail(this.user.emailAddress)) {
          EventBus.dispatchErrorEvent('Error! You must provide a valid email address.');
        }
        else {
          this.saving = true;

          UsersService.getAll({emailAddress: encodeURIComponent(this.user.emailAddress)})
            .then((res) => {
              if(res.data.length > 0) {
                EventBus.dispatchErrorEvent('Error! A user already exists with the provided email address.');
                this.saving = false;
              }
              else if(!this.multisite.name || (this.multisite.name && this.multisite.name.trim().length == 0)) {
                EventBus.dispatchErrorEvent('Error! You must provide a name to create a service provider.');
                this.saving = false;
              }
              else {
                let multisiteToCreate = {
                  name: this.multisite.name
                };

                // Create retailer
                MultiSitesService.createOne(multisiteToCreate)
                  .then((res) => {
                    console.log('Create Multisite complete');

                    this.doSetMultisiteForRetailers(res.data.id);
                    this.createUser({ type: 'multisite', multisite: res.data.id });
                  });
              }
            })
            .catch((err) => {
              this.saving = false;
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
            });

        }
      }
    },

    doSetMultisiteForRetailers: function(multisiteId) {
      for (let r in this.multisite.retailers) {
        RetailersService.replace(this.multisite.retailers[r].id, { multiSite: multisiteId })
          .then((res) => {
            console.log('updated retailer to multisite', res.data.id);
          })
      }
    },


    // Service Provider methods
    // ------------------------
    doCreateServiceProvider: function() {
      if(!this.user.fullName || (this.user.fullName && this.user.fullName.trim().length == 0)) {
        EventBus.dispatchErrorEvent('Error! You must provide a full name.');
      }
      else {
        if(!this.user.emailAddress || (this.user.emailAddress && this.user.emailAddress.trim().length == 0) || !Validator.isEmail(this.user.emailAddress)) {
          EventBus.dispatchErrorEvent('Error! You must provide a valid email address.');
        }
        else {
          this.saving = true;

          UsersService.getAll({emailAddress: encodeURIComponent(this.user.emailAddress)})
            .then((res) => {
              if(res.data.length > 0) {
                EventBus.dispatchErrorEvent('Error! A user already exists with the provided email address.');
                this.saving = false;
              }
              else if(!this.serviceProvider.name || (this.serviceProvider.name && this.serviceProvider.name.trim().length == 0)) {
                EventBus.dispatchErrorEvent('Error! You must provide a name to create a service provider.');
                this.saving = false;
              }
              else {
                let serviceProviderToCreate = {
                  name: this.serviceProvider.name
                };

                // Create retailer
                ServiceProvidersService.createOne(serviceProviderToCreate)
                  .then((res) => {
                    console.log('Create Service Provider complete');

                    let subscriptionData = {
                      type: 'serviceProvider',
                      package: 'advanced',
                      serviceProvider: res.data.id,
                      subscriptionTermMonths: 12
                    };

                    this.createSubscription(subscriptionData);
                  });
              }
            })
            .catch((err) => {
              this.saving = false;
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
            });
        }
      }
    },


    // Shared methods
    // --------------
    createSubscription: function(subscriptionData) {
      console.log('creating subscription...');

      SubscriptionsService.createOne(subscriptionData)
        .then((res) => {
          this.createUser(subscriptionData);
        });
    },

    createUser: function(userData) {
      console.log('creating user...');

      let newUser = {
        emailAddress: this.user.emailAddress,
        fullName: this.user.fullName,
        permissionsGroup: 'admin'
      };

      if(userData.type == 'retailer') {
        newUser.retailer = userData.retailer;
      }
      else if(userData.type == 'serviceProvider') {
        newUser.serviceProvider = userData.serviceProvider;
      }
      else if(userData.type == 'multisite') {
        newUser.multiSite = userData.multisite;
      }

      UsersService.createOne(newUser)
        .then((res) => {
          ResetPasswordService.resetPassword(newUser.emailAddress)
            .then((res) => {
              EventBus.dispatchDialogEvent('Success! The account was created successfully.');
              this.resetComponent();
            });
        });
    },
  },

  computed: {
    retailerResultsFiltered: function() {
      if (!this.searchStringRetailers || (this.searchStringRetailers && this.searchStringRetailers.trim().length == 0)) {
        return this.retailerResults;
      }
      else {
        return this.retailerResults.filter((item) => {
          if(item.name.toLowerCase().indexOf(this.searchStringRetailers.toLowerCase()) > -1) {
            console.log(item.name, ' has ', this.searchStringRetailers);
            return true;
          }

          return false;
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Admin.js